import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { WebActivityLinkedService } from './web-activity.linkedservice';

@Metamodel.model({
    name: 'MicrosoftOutlook',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Email),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Email)
    ]
})

export class MicrosoftOutlookLinkedService extends WebActivityLinkedService {}
